export default "__VITE_ASSET__ByKIIZYH__"